import { LTText, LTTooltip } from '@lambdatestincprivate/lt-components';
import styles from './summary.module.css';

/**
 * One of the four small stat tiles. `value === null` renders an em-dash with
 * an explanatory note — a metric a single pack cannot measure is "—", never a
 * fake 0.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function StatTile(_ref) {
  var title = _ref.title,
    value = _ref.value,
    icon = _ref.icon,
    note = _ref.note;
  var valueText = /*#__PURE__*/_jsx("span", {
    className: "ev-t-num20",
    children: value === null ? '—' : value.toLocaleString()
  });
  return /*#__PURE__*/_jsxs("div", {
    className: styles.tile,
    children: [/*#__PURE__*/_jsx(LTText, {
      text: title,
      color: "#636C76",
      variant: LTText.TextVariant.SUBHEADER_BOLD,
      className: styles.tileTitle
    }), /*#__PURE__*/_jsxs("span", {
      className: styles.tileValue,
      children: [/*#__PURE__*/_jsx("img", {
        src: icon,
        width: 16,
        height: 16,
        alt: "",
        "aria-hidden": "true"
      }), note ? /*#__PURE__*/_jsx(LTTooltip, {
        text: note,
        direction: "bottom",
        children: valueText
      }) : valueText, value === null && note && /*#__PURE__*/_jsx("span", {
        className: "ev-sr-only",
        children: note
      })]
    })]
  });
}